import '../styles/footer.css'

const Footer = () => {
    return (
            <div className='footer'>
                <a href='https://github.com/NelsonMN'>Created By: NelsonMN</a>
            </div>
    )
}

export default Footer